import { Box } from "@biggeo/bg-ui/lab";
import isEmpty from "lodash/isEmpty";
import { Consumers } from "../../common/redux/model";
import { MapboxMapContainer } from "../../map/mapbox/containers/MapContainer";
import { useMap } from "../../map/mapbox/context";
import { MapContextDataset } from "../../map/mapbox/context/types";
import MapStyles, { DEFAULT_MAP_STYLE } from "../../map/views/MapStyles";
import DataSampleDatasets from "../views/DataSampleDatasets";
import { MapLayout } from "../../layouts/MapLayout";
import { getMultiFilters } from "../../map/mapbox/context/utils/general-utils";

interface IDataSamplesContainer {
    readonly samples: MapContextDataset[];
    readonly openGenerateFilePage: boolean;
    readonly setOpenGenerateFilePage: React.Dispatch<
        React.SetStateAction<boolean>
    >;
    readonly channelId: string;
}

const DataSamplesContainer = ({
    samples: initialSamples,
    openGenerateFilePage,
    setOpenGenerateFilePage,
    channelId,
}: IDataSamplesContainer) => {
    const multiFilters = getMultiFilters();

    const { map, isMapLoaded, draw, datasets } = useMap();

    const samples = datasets.filter((d) => !!d.isSample);

    return (
        <MapLayout
            leftOpen
            datasetsTabLabel={"Data Samples"}
            datasets={
                <DataSampleDatasets
                    samples={isEmpty(samples) ? initialSamples : samples}
                />
            }
            maps={
                <MapStyles
                    isMapLoaded={isMapLoaded}
                    map={map}
                    currentStyle={
                        map.current && isMapLoaded
                            ? map.current.getStyle()
                            : undefined
                    }
                    draw={draw}
                    datasets={datasets}
                />
            }
        >
            <Box
                height="100%"
                width="100%"
                sx={{
                    padding: 4,
                    overflow: "auto",
                    borderRadius: (theme) => theme.radius.xs3,
                }}
            >
                <MapboxMapContainer
                    key={Consumers.mapbox}
                    hideSelectMode
                    mapStyle={DEFAULT_MAP_STYLE.key}
                    multiFilters={multiFilters}
                    channelId={channelId}
                    openGenerateFilePage={openGenerateFilePage}
                    setOpenGenerateFilePage={setOpenGenerateFilePage}
                />
            </Box>
        </MapLayout>
    );
};

export default DataSamplesContainer;
